import { useState } from 'react';

let docFont = "Helvetica, Arial, sans-serif";

export function Stats_Spread() {
	//const [docFont, setDocFont] = useState("Helvetica, Arial, sans-serif");
	const [warmUpDone, setWarmUpDone] = useState(false);
	const [targetDone, setTargetDone] = useState(false);
	const [initiation, setInitiation] = useState(false);
	const [terminology, setTerminology] = useState(false);

	function text2Speech(num) {
		copyToClipboard(num);
		window.open("https://www.naturalreaders.com/online/");
	}

	function translateText(num) {
		const e = document.getElementById("label" + num);
		navigator.clipboard.writeText(e.textContent);
		window.open("http://translate.google.com/?sl=en&tl=th&op=translate&text=" + e.textContent.replaceAll("%", "%25"));
	}

	function copyToClipboard(num) {
		const e = document.getElementById("label" + num);
		navigator.clipboard.writeText(e.textContent);
		alert(`Text copied to clipboard. Ready to paste.`)
	}

	//function changeFont() {
	//	const e = document.getElementById("select_font");
	//	setDocFont(e.value);
	//}

	function gotoLT() {
		setInitiation(true);
	}

	function gotoInit() {
		setWarmUpDone(true);
	}

	function gotoTerms() {
		setTargetDone(true);
	}

	function gotoData() {
		setTerminology(true);
	}

	if (!warmUpDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >On your chromebook or laptop:</span>
					</h1>

					<p>
						<label id="label101">
							1. go to Stapplet.com in your web browser <br />
							2. select 1 Quantitative Variable, Single Group <br />
							&nbsp; &nbsp; &nbsp; &nbsp; Variable name = Red Oak Leaf Lengths <br />
							&nbsp; &nbsp; &nbsp; &nbsp; Input = Raw data <br />
							3. enter the following data values: <br />
							&nbsp; &nbsp; &nbsp; &nbsp; 4.9   5.0   5.2   5.3   5.4   5.8   5.8   6.1 6.3   6.4   6.9   7.0   7.2   7.2   7.5 <br />
							4. click the &quot;Begin Analysis&quot; button <br />
							5. select the following Graph Distribution: <br />
							&nbsp; &nbsp; &nbsp; &nbsp; Graph Type = Dotplot <br />
							&nbsp; &nbsp; &nbsp; &nbsp; Show boxplot <br />
							6. show your data plots to your neighbor
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(101)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(101)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoInit()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!initiation) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Let&apos;s Play Taboo</span>
					</h1>

					<p>
						<label id="label102">
							<u>Rules</u><br />
							You and your neighbor are a team. <br />
							Decide who will give the clues and who will do the guessing. <br />
							The one guessing must face away from the board. <br />
							Clues cannot contain ANY form or part of the words <br />
							in the answer or the taboo list. <br />
							<br /><br />
							Wait until I say GO.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(102)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(102)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoLT()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!targetDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Learning Target</span>
					</h1>

					<p>
						<label id="label103">
							Given a set of data represented in <br />
							dotplot, boxplot, or histogram form, <br />
							I can calculate the range, interquartile range, <br />
							and standard deviation, deciding which <br />
							measure of spread is most appropriate <br />
							for understanding the data set, <br />
							achieving 75% accuracy on classwork examples.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(103)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(103)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoTerms()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!terminology) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Terminology</span>
					</h1>

					<p>
						<label id="label104">
							<b>Mean</b> = the mathematical average of all values in a data set <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(104)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(104)}>Translate</button>

					<p>
						<label id="label105">
							<b>Median</b> = the middle value among a data set <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(105)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(105)}>Translate</button>

					<p>
						<label id="label106">
							<b>Range</b> = the interval between the lowest and highest values in a data set <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(106)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(106)}>Translate</button>

					<p>
						<label id="label107">
							<b>Quartiles</b> = subdivisions that each define a continuous range containing a quarter of the values in a data set <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(107)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(107)}>Translate</button>

					<p>
						<label id="label108">
							<b>Interquartile Range (IQR)</b> = the two inner or center quartiles of a data set <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(108)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(108)}>Translate</button>

					<p>
						<label id="label109">
							<b>Standard Deviation</b> = a measure of the amount of variation of the values of a data set about its mean
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(109)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(109)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoData()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Demonstration Data</span>
					</h1>

					<p>
						<label id="label110">
							Here are the high temperature readings in degrees Fahrenheit for Phoenix, Arizona, for each day in July of a recent year.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(110)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(110)}>Translate</button>

					<p>
						<label id="label111">
							111 84 115 108 106 109 111 113 104 103 97 99 104 110 109 100 105 107 102 101 107 93 101 105 99 102 104 108 106 106 109
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => copyToClipboard(111)}>Copy to Clipboard</button>
				</div >
			</>
		);
	}
}
